<template>
   <div class="page-info">
      <div class="title">{{title}}</div>
      <div class="subtitle" v-html="subTitle"></div>
      <div class="page-line"></div>
   </div>
</template>

<script>
   export default {
      props: { 
         title: String,
         subTitle: String
      },
   }
</script>

